<template>
  <div class="com-form-wrap">
    <div class="com-form-con" ref="formCon">
      <div class="wp clearfix">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FormWrap",
  props: {
    title: String
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.com-form-wrap {
  /*height: 110px;*/
  .com-form-con {
    > div {
      padding: 25px 18px;
      box-sizing: border-box;
      background: rgba(255, 255, 255, 0.2);
    }
    &.fixed {
      position: fixed;
      z-index: 100;
      top: 0;
      left: 0;
      width: 100%;
      background: linear-gradient(165deg, #5250c3, #2b85e2);
      > div {
        background: none;
      }
    }
  }
  .com-form-item {
    width: 100%;
    margin-bottom: 30px;
  }
  .form-btn {
    /*width: 167px;*/
    width: 100%;
    height: 50px;
    background: #207bf9;
    border-radius: 4px;
    text-align: center;
    font-size: 16px;
    color: #fff;
    cursor: pointer;
    border: none;
    margin-bottom: 18px;
  }
  .com-form-con-link {
    text-align: center;
    a {
      color: #207bf9;
      text-decoration: none;
    }
  }
}
</style>
